import Prescribed from "./Medications/PrescribedMedication/Prescribed";
import TelephoneOrders from "./Medications/TelephoneOrders/TelephoneOrders";
import VerticalTabs from "../../shared/ReusableComponents/VerticalTabs";
import NurseInitiated from "./Medications/NurseInitiated/NurseInitiated";
import { MedicineType, OnceOnlyMedicine } from "../../shared/constants/enums";
import OneTimeMedication from "./Medications/OneTimeMedicine/OneTimeMedication";

export function Medications({ id }: { id: number }) {
  const GetTabs = () => [
    {
      Text: "PRN Medicine",
      Component: <Prescribed caseId={id} medicineType={MedicineType.PRN} />,
    },
    {
      Text: "Regular Medicine",
      Component: <Prescribed caseId={id} medicineType={MedicineType.REGULAR} />,
    },
    {
      Text: "Variable Dose Medicine",
      Component: (
        <Prescribed caseId={id} medicineType={MedicineType.VARIABLE} />
      ),
    },
    {
      Text: "Nurse Initiated Medicine",
      Component: <NurseInitiated caseId={id} />,
    },
    {
      Text: "Telephone Orders",
      Component: <TelephoneOrders caseId={id} />,
    },
    {
      Text: OnceOnlyMedicine,
      Component: <OneTimeMedication caseId={id} />,
    },
  ];
  return <VerticalTabs GetTabs={GetTabs} />;
}
